import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { TrialAccountAlertComponent } from './trial-account-alert.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        MaterialModule
    ],
    declarations: [TrialAccountAlertComponent],
    exports: [TrialAccountAlertComponent]
})
export class TrialAccountAlertModule {
}
